(function documentContainerControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'documentContainerService', 'containerTypeService', 'authExtend', 'alerts', 'storageService', 'documentContainerAction', '$filter',
            function documentContainerController($scope, config, $state, $translate, errors, documentContainerService, containerTypeService, authExtend, alerts, storageService, documentContainerAction, $filter) {

                $scope.enableMassiveDigitalization = authExtend.isInRole('DOCUMENT MASSIVE DIGITALIZATION');
                $scope.modifyOptions = authExtend.isInRole('DOCUMENTCONTAINER WRITE');
                $scope.checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                $scope.accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');
                $scope.modifyDocumentOptions = $scope.checkInVersioned || $scope.accesCheckIn;
                $scope.deleteBtn = authExtend.isInRole('DOCUMENTCONTAINER DELETE');
                $scope.userId = authExtend.getUserId();
                $scope.shareBtn = authExtend.isInRole('SHARE');
                $scope.canCheckInOutAll = authExtend.isInRole('DOCUMENTCONTAINER CHECKINOUTALL');
                $scope.panelOpen = true;

                $scope.orders = [
                    { value: 'LastModifiedDate ASC', description: 'LastModifiedDate ASC' },
                    { value: 'LastModifiedDate DESC', description: 'LastModifiedDate DESC' },
                    { value: 'Name ASC', description: 'Name ASC' },
                    { value: 'Name DESC', description: 'Name DESC' }
                ];

                $scope.order = $scope.orders[1];
                $scope.ctAllChecked = storageService.getCtAllCheckedFilter();
                $scope.panelOpen = true;
                $scope.find = storageService.getMyContainerFilter();
                $scope.loadActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    $scope.items.forEach(function (cont) {
                        containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], cont.containerTypeId).then(function (r) { cont.modifyOptions = r; });
                        containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER CHECKINOUTALL'], cont.containerTypeId).then(function (r) { cont.canCheckInOutAll = r; });
                        containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER DELETE'], cont.containerTypeId).then(function (r) { cont.deleteBtn = r; });
                        containerTypeService.isContainertypeInRole(['DOCUMENTVERSIONED WRITE'], cont.containerTypeId).then(function (r) { cont.checkInVersioned = r; });
                        containerTypeService.isContainertypeInRole(['DOCUMENT WRITE'], cont.containerTypeId).then(function (r) { cont.accesCheckIn = r; });
                        containerTypeService.isContainertypeInRole(['FILE READ'], cont.containerTypeId).then(function (r) { cont.viewPDFbtn = r; });
                        containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], cont.containerTypeId).then(function (r) { cont.downloadAllBtn = r; });
                        cont.modifyDocumentOptions = $scope.modifyDocumentOptions;
                    });

                }

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                containerTypeService.getFunctionsTypes(['DOCUMENTCONTAINER WRITE', 'DOCUMENTCONTAINER READ', 'DOCUMENTCONTAINER DELETE', 'DOCUMENTCONTAINER CHECKINOUTALL']).then(function (result) {
                    $scope.find.Actions = result;
                }, function (error) {
                    errors.showError(error);
                });

                $scope.items = [];

                $scope.fillDocContainerMetadata = function (container) {

                    if (container.metadatas === undefined) {
                        documentContainerService.getById(container.id).then(function (result) {
                            container.metadatas = result.metadatas;

                            container.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });

                            container.hasMetadata = container.metadatas.length !== 0;
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                    }
                }

                $scope.fillAccordion = function () {
                    $scope.items.forEach(function (item) {
                        var accordionIsOpen = false;
                        Object.defineProperty(item, "accordionIsOpen", {
                            get: function () { return accordionIsOpen; },
                            set: function (newValue) {

                                if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                                    if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "cont") {

                                        accordionIsOpen = newValue;

                                        if (accordionIsOpen) {
                                            $scope.fillDocContainerMetadata(item);
                                        }
                                    }
                                }
                            }
                        });
                    });
                };

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.containerTypeIds = [];

                    $scope.find.containerTypes.forEach(function (ct) {
                        if (ct.checked) {
                            $scope.containerTypeIds.push(ct.containerTypeId);
                        }
                    });
                    storageService.setMyContainerFilter($scope.find);
                    return documentContainerService.getCheckedOut($scope.find.name, $scope.data.currentPage, $scope.data.itemsPerPage, $scope.order.value, $scope.containerTypeIds).then(function getOk(result) {
                        $scope.items = result.value.containers;
                        $scope.find.containerTypes = result.value.containerTypes;
                        $scope.loadActions($scope.items);
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = result.from;

                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                        if ($scope.items.length > 0) {
                            $scope.fillAccordion();
                        }

                        $scope.find.containerTypes.forEach(function (item) {
                            if ($scope.containerTypeIds.length === 0) {
                                item.checked = true;
                                $scope.ctAllChecked = true;
                            }
                            else {
                                var dtFound = $filter('filter')($scope.containerTypeIds, item.containerTypeId, true);
                                if (dtFound.length > 0) {
                                    item.checked = true;
                                }
                            }
                        });

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.view = function (container) {
                    storageService.setStateBackFind('document-container-find');
                    $state.go('document-container-detail', { id: container.id });
                };

                $scope.add = function () {
                    $state.go('document-container-add');
                };

                $scope.checkIn = function (container) {
                    documentContainerAction.checkIn(container).then(function getOk() {
                        if ($scope.items.length === 1) {
                            $scope.clearFilters();
                        }
                        $scope.findAction();
                    });
                };

                $scope.checkInAll = function (container) {
                    documentContainerAction.checkInAll(container).then(function getOk() {
                        $scope.findAction();
                    });
                };

                $scope.checkout = function (document) {
                    return documentContainerService.checkout(document).then(function getOk() {
                        $scope.findAction();
                        errors.showSuccess('DocumentContainerCheckOutSucces');
                    }, function (error) {
                        $scope.findAction();
                        errors.showError(error);
                    });
                };

                $scope.modify = function (container) {
                    storageService.setStateBackFind('document-container-find');
                    $state.go('document-container-modify', { id: container.id });
                };

                $scope.toggleContTypeCheck = function () {
                    $scope.find.containerTypes.forEach(function (ct) {
                        ct.checked = !$scope.ctAllChecked;
                    });
                    $scope.ctAllChecked = !$scope.ctAllChecked;
                };

                $scope.clearFilters = function () {
                    storageService.clearMyContainerFilter();
                    storageService.clearDtAllcheckedFilter();
                    $scope.find.containerTypes.forEach(function (item) {
                        item.checked = true;
                    });

                    $scope.find.name = null;
                    $scope.dtAllChecked = true;
                    $scope.items = [];
                    $scope.findAction();
                }

                $scope.deleteContainer = function (document) {
                    return documentContainerAction.deleteContainer(document).then(function (doc) {
                        $scope.findAction();
                    });
                };

                $scope.viewPDF = function (cont) {
                    storageService.setStateBackFind('document-container-find');
                    $state.go('file-document-container-detail', { id: cont.id });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (cont) {
                            cont.check = $scope.checkAll;
                        });
                    }
                };

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };


                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.downloadContainer = function (cont) {
                    return documentContainerAction.downloadFilesContainer(cont);
                }

                $scope.findAction();
            }
        ]);
})();